import { userPilotEvents } from '../../../../common/Userpilot/userpilotHelper';
import { selectProductBuilderData } from '../../../../redux/slicers/productBuilder/productBuilder.slicer';
import { getAppState } from '../../../../redux/store';
const { trackUserPilotEvent } = userPilotEvents();

export const createNewMattress = ({ ctaType, id, name }) => {
  trackUserPilotEvent('Mattress - Started', {
    cta_type: ctaType,
    mattress_id: id,
    mattress_name: name,
  });
};

export const renameMattress = ({ oldMattressName, id, name, actionFrom }) => {
  trackUserPilotEvent('Mattress - Rename', {
    action_from: actionFrom,
    mattress_id: id,
    mattress_name: name,
    old_mattress_name: oldMattressName,
  });
};

export const deleteMattress = ({ id, name, actionFrom }) => {
  trackUserPilotEvent('Mattress - Delete', {
    action_from: actionFrom,
    mattress_id: id,
    mattress_name: name,
  });
};

export const mattressBtnClickEvents = ({ btnName }) => {
  const productBuilderData = selectProductBuilderData(getAppState());
  trackUserPilotEvent(`${btnName}_Clicked`, {
    mattress_id: productBuilderData?.id,
    mattress_name: productBuilderData?.name,
  });
};

export const otherMattressEvents = ({ eventName, properties = {} }) => {
  const productBuilderData = selectProductBuilderData(getAppState());
  trackUserPilotEvent(eventName, {
    mattress_id: productBuilderData?.id,
    mattress_name: productBuilderData?.name,
    ...properties,
  });
};
